import { definitions } from 'api/generated/photo'
import { findNextIndex } from 'components/page/PhotoViewer/function/findNextIndex'

export const findNextPhotoId = (
  photos: definitions['OmniAlbumPhoto'][],
  selectedIndex: number,
  direction: number
) => photos[findNextIndex(direction, selectedIndex, photos)].photoId
